import React, { useEffect, useState, useRef, useCallback } from 'react';

import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import { useNavigate, useLocation } from 'react-router-dom';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import loadingGif from '../assets/images/Loading-Animation.gif';
import 'bootstrap-icons/font/bootstrap-icons.css';
import greenbg from '../assets/images/Yellow.png';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import {
    Chart,
    PieController,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    BarController,
    BarElement,
    CategoryScale,
    LinearScale,
    DoughnutController
} from 'chart.js';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { generatereport, Audit } from '../components/ApiProperty';
import { useChatbot } from "../components/ChatbotContext";
import { Modal } from 'react-bootstrap';
import { useSession } from '../components/SessionContext';

Chart.register(
    PieController,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    BarController,
    BarElement,
    CategoryScale,
    LinearScale,
    DoughnutController
);

const Adashboard = () => {
    const [templateDeptDetails, setTemplateDeptDetails] = useState(null);
    const navigate = useNavigate();
    const { setIsChatbotMinimized } = useChatbot();
    const [detailData, setDetailData] = useState([0, 0, 0]); // [Created, Updated, Inactive]
    const location = useLocation();
    const [currentSlide, setCurrentSlide] = useState(0); // 0: Users Summary, 1: Templates Summary
    const [chartData, setChartData] = useState({});
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [departmentDetails, setDepartmentDetails] = useState({});
    const [templateData, setTemplateData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { sessionId } = useSession();

    const chartContainerRef = useRef(null);
    const chartInstanceRefpdf = useRef(null); // This holds the Chart instance
    const chartRef = useRef(null);
    const chartRefpdf = useRef(null);
    const canvasRef = useRef(null);
    const chartInstance = useRef(null);
    const [selectedCreatedCount, setSelectedCreatedCount] = useState(0);
    const [Userdetails, setUserDetails] = useState(null);
    const [userActivityData, setUserActivityData] = useState({});
    const [flattenedUsers, setFlattenedUsers] = useState([]);
    const [selectedRange, setSelectedRange] = useState('All');
    const [selectedUpdatedCount, setSelectedUpdatedCount] = useState(0);
    const [selectedInactiveCount, setSelectedInactiveCount] = useState(0);
    const createdTemplateChartRef = useRef(null);
    const templateinforef = useRef(null);
    const [responseData, setResponseData] = useState([]);
    const [flattenedTemplateData, setFlattenedTemplateData] = useState([]);
    const createdTemplateChartInstance = useRef(null);
    const [userDateFilter, setUserDateFilter] = useState("All");
    const [templateDateFilter, setTemplateDateFilter] = useState('All');
    const [selectedTemplateDept, setSelectedTemplateDept] = useState(null);
    const [selectedAction, setSelectedAction] = useState(null);
    const [canShowChart, setCanShowChart] = useState(false); // <-- NEW
    const [barChartData, setBarChartData] = useState([0, 0, 0]); // Created, Modified, Inactive 
    const [selectedRole, setSelectedRole] = useState(null);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [dateFilter, setDateFilter] = React.useState('all'); // default 'all'
    const [dateFilterPdf, setDateFilterpdf] = useState("All");
    const userDept = localStorage.getItem('dept');
    const [updatedTemplateData, setUpdatedTemplateData] = useState([]);
    const [mergedTemplateData, setMergedTemplateData] = useState([]);
    const [modalMessage, setModalMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // 'success', 'warning', 'danger'


    const [showDoughnut, setShowDoughnut] = useState(true); // default to true
    const [tableDetails, setTableDetails] = useState({
        created: [],
        updated: [],
        inactive: []
    });


    const handlePrev = () => setCurrentSlide(prev => (prev === 0 ? 1 : 0));
    const handleNext = () => setCurrentSlide(prev => (prev === 1 ? 0 : 1));

    let csrfToken = sessionStorage.getItem("tokenizedSession");


    useEffect(() => {
        if (userDept !== 'IT' && currentSlide === 0) {
            setCurrentSlide(1); // Force show template summary for non-IT users
        }
    }, [userDept, currentSlide]);
    const handleFbc = (e) => {
        e.preventDefault();
        navigate('/gapsyFbc');
        // Additional logic if needed
    };

    const handleIbm = (e) => {
        e.preventDefault();
        navigate('/gapsyIbm');
    };
    const handleDashboardAI = () => {
        // Open the chatbot
        setIsChatbotMinimized(false);
    };
    const handleModiyTemplate = (e) => {
        e.preventDefault();
        navigate('/gapsyMet');
    }
    const handleReAssign = () => {
        navigate('/gapsyReAssign');
    };

    const handleUserCreations = () => {
        navigate('/gapsyuserregistration');
    };
    const handleUserModify = () => {
        navigate('/gapsyusermodify');
    };
    useEffect(() => {
        if (tableDetails) {
            setSelectedCreatedCount(Array.isArray(tableDetails.created) ? tableDetails.created.length : 0);
            setSelectedUpdatedCount(Array.isArray(tableDetails.updated) ? tableDetails.updated.length : 0);
            setSelectedInactiveCount(Array.isArray(tableDetails.inactive) ? tableDetails.inactive.length : 0);
        }
    }, [tableDetails]);
    // FETCH: Department User Roles Data chart 

    useEffect(() => {
        const fetchDataAndRenderChart = async () => {
            try {
                setIsLoading(true);
                const userId = localStorage.getItem('userid');
                const userRole = localStorage.getItem('userRole');
                const department = localStorage.getItem('dept');
                const activity = 'C';
                const isAllowed = department === 'IT' && (userRole === 'Admin' || userRole === 'Superuser');
                setCanShowChart(isAllowed);
                if (!isAllowed) return;
                const config = {
                    headers: { userId, "x-csrf-token": csrfToken },
                    withCredentials: true,
                    params: { userId, userRole, dept: department, Activity: activity },
                };
                const response = await axios.post(generatereport, {}, config);
                if (response.status !== 200) throw new Error('Failed to fetch data');
                const result = response.data;
                if (result.status === 'success') {
                    const departmentData = result.DepartmentDetails;
                    const userDetails = result.UserDetails;
                    setDepartmentDetails(departmentData); // Optional if you're using this elsewhere


                    setUserDetails(userDetails); // You can define a new state to store user details
                    const departments = Object.keys(departmentData);
                    setUserActivityData(userDetails); // renamed from setUserDetails
                    // Flatten all users into one array
                    const flatList = [];
                    departments.forEach((dept) => {
                        const users = userDetails[dept] || [];
                        users.forEach((user) => {
                            flatList.push({
                                sno: flatList.length + 1,
                                userId: user.userId,
                                fullName: `${capitalizeFirstLetter(user.firstName)} ${capitalizeFirstLetter(user.lastName)}`,
                                userRole: user.userRole,
                                dept: user.orgHierarchy,
                                createdBy: user.Created_by,
                                createdDate: user.accountCreatedDate,
                                totalLogins: user.totalLogins,
                                today_login: user.todayLogins,
                                last_3days_logins: user.last3DaysLogins,
                                last_7days_logins: user.last7DaysLogins,
                                last_30Days_Logins: user.last30DaysLogins,
                                lastActivity: user.lastActivity,
                                active: user.active,
                                frequencyActivity: user.Frequnce_activity,
                                frequencyActivity_today: user.Frequency_activity_today,
                                frequencyActivity_3days: user.Frequency_activity_3days,
                                frequencyActivity_7days: user.Frequency_activity_7days,
                                frequencyActivity_30days: user.Frequency_activity_30days,
                            });
                        });
                    });
                    setFlattenedUsers(flatList);
                    const totals = departments.map((dep) => {
                        const { Admin = 0, Maker = 0, Checker = 0, Superuser = 0 } = departmentData[dep];
                        return Admin + Maker + Checker + Superuser;
                    });

                    const totalUsers = totals.reduce((a, b) => a + b, 0);
                    const userMapByDept = {};
                    departments.forEach((dept) => {
                        userMapByDept[dept] = userDetails[dept] || [];
                    });

                    // Initial safe colors: yellow, violet, green, pink
                    const initialColors = ['#FFCE56', '#9966FF', '#7AC74F', '#FF69B4']; // Pink added

                    function generateSafeColors(count) {
                        const colors = [...initialColors];
                        let hue = 30;

                        while (colors.length < count) {
                            // Skip red (0–20, 340–360) and blue (180–260)
                            if ((hue >= 0 && hue <= 20) || (hue >= 180 && hue <= 260) || (hue >= 340 && hue <= 360)) {
                                hue = (hue + 15) % 360;
                                continue;
                            }

                            const color = `hsl(${hue}, 70%, 55%)`;
                            if (!colors.includes(color)) {
                                colors.push(color);
                            }

                            hue = (hue + 30) % 360;
                        }

                        return colors.slice(0, count);
                    }

                    // Usage in chart
                    setChartData({
                        labels: departments,
                        datasets: [
                            {
                                data: totals,
                                backgroundColor: generateSafeColors(departments.length),
                                hoverOffset: 4,
                            },
                        ],
                        totalUsers,
                        usersByDepartment: userMapByDept,
                    });

                }
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching chart data:', error);
            }

        };

        fetchDataAndRenderChart();

        return () => {
            if (chartInstance.current) chartInstance.current.destroy();
        };
    }, []);


    // ------- start the 1st chart  doughnut ----------

    useEffect(() => {

        if (currentSlide !== 0) return; // Only run this effect on Users Summary slide
        // Skip chart rendering if user role table is shown (canvas not rendered)
        if (selectedRole && filteredUsers.length > 0) {
            return;
        }

        if (!chartData.labels || !chartData.datasets) return;

        if (!chartRef.current) {
            console.warn("Canvas ref is not available in useEffect.");
            return;
        }

        const ctx = chartRef.current.getContext('2d');
        if (chartInstance.current) chartInstance.current.destroy();

        if (!selectedDepartment) {
            chartInstance.current = new Chart(ctx, {
                type: 'doughnut',
                data: chartData,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'bottom',
                            align: 'center',
                            labels: {
                                color: 'black',
                                font: {
                                    size: 10,
                                    weight: 'normal',
                                    family: 'Arial, sans-serif',
                                    useBorderRadius: false, // remove rounded corners if any

                                },
                                boxWidth: 15,
                                padding: 10,
                                generateLabels(chart) {
                                    const dataset = chart.data.datasets[0];
                                    const labels = chart.data.labels;

                                    return labels.map((label, i) => ({
                                        text: `${label} (${dataset.data[i]})`,
                                        fillStyle: dataset.backgroundColor[i],
                                        strokeStyle: 'transparent', // ✅ remove border
                                        lineWidth: 0,               // ✅ remove border
                                        hidden: !chart.isDatasetVisible(0),
                                        index: i,
                                    }));
                                },
                            },
                        },
                        tooltip: { enabled: true },
                    },
                    elements: {
                        arc: { borderWidth: 0 },
                    },
                    onClick: (e, elements) => {
                        if (elements.length > 0) {
                            const index = elements[0].index;
                            const clickedDept = chartData.labels[index];
                            setSelectedDepartment(clickedDept);
                        }
                    },
                },
                plugins: [
                    {
                        id: 'segment3DEffect',
                        afterDatasetDraw(chart) {
                            const { ctx } = chart;
                            const meta = chart.getDatasetMeta(0);
                            const dataset = chart.data.datasets[0];

                            ctx.save();

                            meta.data.forEach((arc, index) => {
                                const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;

                                const gradient = ctx.createRadialGradient(x, y, innerRadius, x, y, outerRadius);
                                const baseColor = dataset.backgroundColor[index];

                                gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)');
                                gradient.addColorStop(0.5, baseColor);
                                gradient.addColorStop(1, 'rgba(0, 0, 0, 0.15)');

                                ctx.fillStyle = gradient;

                                ctx.beginPath();
                                ctx.moveTo(x, y);
                                ctx.arc(x, y, outerRadius, startAngle, endAngle);
                                ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                                ctx.closePath();
                                ctx.fill();

                                ctx.shadowColor = 'rgba(0,0,0,0.08)';
                                ctx.shadowBlur = 3;
                                ctx.shadowOffsetX = 1;
                                ctx.shadowOffsetY = 1;

                                ctx.strokeStyle = 'rgba(0, 0, 0, 0.08)';
                                ctx.lineWidth = 1;
                                ctx.beginPath();
                                ctx.arc(x, y, outerRadius, startAngle, endAngle);
                                ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                                ctx.closePath();
                                ctx.stroke();
                                ctx.shadowColor = 'transparent';
                                ctx.shadowBlur = 0;
                                ctx.shadowOffsetX = 0;
                                ctx.shadowOffsetY = 0;
                            });
                            ctx.restore();
                        },
                    },
                    {
                        id: 'centerText',
                        beforeDraw(chart) {
                            const { ctx, chartArea, data } = chart;
                            const total = data.totalUsers || 0;
                            ctx.save();
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            ctx.font = '20px Arial';
                            ctx.fillStyle = 'black';
                            ctx.fillText('Total', (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 - 20);
                            ctx.font = '30px Arial';
                            ctx.fillText(total.toString(), (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 + 10);
                            ctx.restore();
                        },
                    },
                    {
                        id: 'segmentCounts',
                        afterDatasetDraw(chart) {
                            const { ctx } = chart;
                            const dataset = chart.data.datasets[0];
                            const meta = chart.getDatasetMeta(0);

                            ctx.save();
                            ctx.fillStyle = 'black';
                            ctx.font = 'bold 14px Arial';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';

                            meta.data.forEach((arc, index) => {
                                const { x, y } = arc.tooltipPosition();
                                const value = dataset.data[index];
                                ctx.fillText(value, x, y);
                            });

                            ctx.restore();
                        },
                    },
                ],
            });
        } else {
            if (departmentDetails && departmentDetails[selectedDepartment]) {
                renderBarChart(selectedDepartment);
            } else {
                console.warn('No data for selected department:', selectedDepartment);
            }

        }
    }, [currentSlide, chartData, selectedDepartment, departmentDetails, selectedRole, filteredUsers]);

    const renderBarChart = (selectedDepartment) => {
        if (!selectedDepartment || !departmentDetails[selectedDepartment]) return;

        const {
            Admin = 0,
            Maker = 0,
            Checker = 0,
            Superuser = 0
        } = departmentDetails[selectedDepartment];

        if (!chartRef.current) {
            console.warn("Canvas ref is not available in useEffect.");
            return;
        }

        const ctx = chartRef.current.getContext('2d');
        if (chartInstance.current) chartInstance.current.destroy();

        const labels = [];
        const data = [];
        const backgroundColors = [];
        const roleMap = [];

        // Gradient definitions
        const createGradient = (startColor, endColor) => {
            const gradient = ctx.createLinearGradient(0, 0, 0, 300);
            gradient.addColorStop(0, startColor);
            gradient.addColorStop(1, endColor);
            return gradient;
        };

        if (Admin > 0) {
            labels.push(`Manager (${Admin})`);
            data.push(Admin);
            backgroundColors.push(createGradient("#967aa1", "#07beb8"));  // gradient1
            roleMap.push("admin");
        }
        if (Maker > 0) {
            labels.push(`Maker (${Maker})`);
            data.push(Maker);
            backgroundColors.push(createGradient("#967aa1", "#f25c54"));  // gradient2
            roleMap.push("maker");
        }
        if (Checker > 0) {
            labels.push(`Checker (${Checker})`);
            data.push(Checker);
            backgroundColors.push(createGradient("#967aa1", "#133c55"));  // gradient3
            roleMap.push("checker");
        }
        if (Superuser > 0) {
            labels.push(`Superuser (${Superuser})`);
            data.push(Superuser);

            backgroundColors.push(createGradient("#967aa1", "#ffc43d"));  // gradient4
            roleMap.push("superuser");
        }

        chartInstance.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets: [{
                    data,
                    backgroundColor: backgroundColors,
                    borderRadius: 6,
                    barPercentage: 0.5,
                    categoryPercentage: 0.5,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            title: (context) => context[0].label.split(" (")[0],  // Add this line
                            label: (context) => `Count: ${context.parsed.y}`,    // Modified this line
                        }
                    },
                },
                scales: {
                    x: {
                        ticks: {
                            color: 'black',
                            maxRotation: 0,
                            minRotation: 0,
                            font: {
                                size: 8, // 👈 Reduce this value (try 8, 10, etc.)
                                weight: 'normal',
                                family: 'Arial',
                            },
                        },
                        grid: { display: false },
                        title: {
                            display: true,
                            text: 'Roles',
                            color: 'black',
                            font: {
                                size: 14,
                                weight: 'bold',
                            },
                        },
                    },
                    y: {
                        beginAtZero: true,
                        ticks: {
                            color: "black",
                            stepSize: 1,
                            callback: function (value) {
                                return Number.isInteger(value) ? value : null;
                            },
                            font: {
                                size: 12,
                            }
                        },
                        title: {
                            display: true,
                            text: "Count",
                            color: "black",
                            font: { size: 14, weight: "bold" },
                        },
                    },
                },

                onClick: (e, elements) => {
                    if (elements.length > 0) {
                        const index = elements[0].index;
                        const clickedRole = roleMap[index];
                        const users = chartData.usersByDepartment[selectedDepartment] || [];

                        const filteredUsers = users.filter(
                            user => user.userRole?.toLowerCase() === clickedRole
                        );
                        setSelectedRole(clickedRole);
                        setFilteredUsers(filteredUsers);
                    }
                },
            },
            plugins: [
                {
                    id: 'barGlassy3D',
                    afterDatasetDraw(chart) {
                        const { ctx } = chart;
                        const meta = chart.getDatasetMeta(0);
                        const dataset = chart.data.datasets[0];

                        ctx.save();

                        meta.data.forEach((bar, i) => {
                            const { x, y, base } = bar;
                            const width = bar.width;
                            const height = base - y;
                            const left = x - width / 2;
                            const top = y;
                            const depthOffset = 4;

                            ctx.fillStyle = 'rgba(0, 0, 0, 0.08)';
                            ctx.fillRect(left + depthOffset, top + depthOffset, width, height);

                            ctx.fillStyle = dataset.backgroundColor[i];
                            ctx.fillRect(left, top, width, height);

                            ctx.strokeStyle = 'rgba(0,0,0,0.1)';
                            ctx.lineWidth = 1;
                            ctx.strokeRect(left, top, width, height);
                        });

                        ctx.restore();
                    },
                },
            ],
        });
    };


    const fetchDataAndDrawChart = useCallback(async () => {
        try {
            setIsLoading(true);
            const userId = Number(localStorage.getItem('userid'));
            const userRole = localStorage.getItem('userRole');
            const department = localStorage.getItem('dept');

            const activity = 'C';
            const config = {
                headers: { userId, "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { userId, userRole, Activity: activity, dept: department },
            };

            const response = await axios.post(Audit, {}, config);
            const actions = response.data.userDetails.actions;

            const createdAction = actions.find(action => action.actionType === 'Created a Template');
            if (!createdAction) return;

            const createdDetails = createdAction.actionDetails;
            const flattenedCreatedData = [];

            Object.entries(createdDetails).forEach(([dept, deptData]) => {
                deptData.tables.forEach((table) => {
                    table.details.forEach((detail) => {
                        if (
                            detail.completed_activity === 'Created a Template' &&
                            detail.templateInfo &&
                            detail.templateInfo.template_info
                        ) {
                            const info = detail.templateInfo.template_info;
                            flattenedCreatedData.push({
                                department: dept,
                                tableName: detail.Tablename,
                                createdBy: info.created_by,
                                createdDate: info.created_date,
                                checker: info.checker,
                                numCols: info.num_of_cols,
                                numericCount: info.numeric_type_count,
                                charCount: info.char_type_count,
                                dateCount: info.date_type_count,
                                isActive: info.is_active === 0 ? 'Active' : 'In-Active',
                            });
                        }
                    });
                });
            });

            const createdLabels = Object.keys(createdDetails);
            const createdData = createdLabels.map((dept) => createdDetails[dept].count);
            const totalCreated = createdData.reduce((sum, count) => sum + count, 0);

            const initialColors = ['#FFCE56', '#9966FF', '#7AC74F', '#FF69B4'];
            const excludedHues = [
                { from: 0, to: 10 },     // Red
                { from: 180, to: 260 },  // Blue/Cyan
            ];
            const isExcludedHue = (hue) =>
                excludedHues.some((range) => hue >= range.from && hue <= range.to);
            const generateSafeColors = (requiredCount) => {
                const colors = [...initialColors];
                let attempts = 0;
                while (colors.length < requiredCount && attempts < requiredCount * 10) {
                    attempts++;
                    const hue = Math.floor(Math.random() * 360);
                    if (isExcludedHue(hue)) continue;
                    const saturation = Math.floor(Math.random() * 30) + 70;
                    const lightness = Math.floor(Math.random() * 30) + 45;
                    const hsl = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
                    if (!colors.includes(hsl)) {
                        colors.push(hsl);
                    }
                }
                return colors.slice(0, requiredCount);
            };

            const templateChartData = {
                labels: createdLabels,
                datasets: [
                    {
                        label: 'Created a Template',
                        data: createdData,
                        backgroundColor: generateSafeColors(createdData.length),
                        borderWidth: 0,
                    },
                ],
                totalUsers: totalCreated,
            };

            setTemplateData(templateChartData);
            setResponseData(flattenedCreatedData);
            setFlattenedTemplateData(flattenedCreatedData);

            // Process Updated a Template
            const updatedAction = actions.find((action) => action.actionType === 'Updated a Template');
            let flattenedUpdatedData = [];
            if (updatedAction) {
                const updatedDetails = updatedAction.actionDetails;
                Object.entries(updatedDetails).forEach(([dept, deptData]) => {
                    deptData.tables.forEach((table) => {
                        table.details.forEach((detail) => {
                            if (detail.completed_activity === 'Updated a Template') {
                                flattenedUpdatedData.push({
                                    department: dept,
                                    tableName: detail.Tablename,
                                    modifiedBy: detail.Modified_By || '',
                                    modifiedDate: detail.Modified_Date || '',
                                });
                            }
                        });
                    });
                });
                setUpdatedTemplateData(flattenedUpdatedData);
            }

            // Merge data
            const updatedMap = {};
            flattenedUpdatedData.forEach((upd) => {
                const key = `${upd.department}_${upd.tableName}`;
                updatedMap[key] = upd;
            });

            const mergedData = flattenedCreatedData.map((created) => {
                const key = `${created.department}_${created.tableName}`;
                return {
                    ...created,
                    modifiedBy: updatedMap[key]?.modifiedBy || '',
                    modifiedDate: updatedMap[key]?.modifiedDate || '',
                };
            });



            setMergedTemplateData(mergedData);
            // 🔁 Department-wise conditional logic
            if (department !== 'IT') {
                await handleDepartmentClick(department);
            } else {
                setSelectedTemplateDept(null);
                setShowDoughnut(true);
            }
            setIsLoading(false);
        } catch (err) {
            console.error('Failed to fetch data:', err);
        }
    }, []);

    useEffect(() => {
        fetchDataAndDrawChart();
    }, [fetchDataAndDrawChart]);


    // ---- START DOUHGNUT CAHRT TEMPLATE ----------------

    useEffect(() => {
        if (currentSlide !== 1) return; // Exit if not on templates slide


        if (!createdTemplateChartRef.current) return;

        const ctx = createdTemplateChartRef.current.getContext('2d');
        if (!ctx) return;

        if (createdTemplateChartInstance.current) {
            createdTemplateChartInstance.current.destroy();
            createdTemplateChartInstance.current = null;
        }

        if (showDoughnut && !selectedTemplateDept) {

            createdTemplateChartInstance.current = new Chart(ctx, {
                type: 'doughnut',
                data: templateData,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'bottom',
                            align: 'center',
                            labels: {
                                color: 'black',
                                font: {
                                    size: 10,
                                    weight: 'normal',
                                    family: 'Arial, sans-serif',
                                },
                                boxWidth: 15,
                                padding: 10,
                                useBorderRadius: false, // remove rounded corners if any
                                generateLabels(chart) {
                                    const dataset = chart.data.datasets[0];
                                    const labels = chart.data.labels;
                                    return labels.map((label, i) => ({
                                        text: `${label} (${dataset.data[i]})`,
                                        fillStyle: dataset.backgroundColor[i],
                                        strokeStyle: 'transparent', // ✅ remove border
                                        lineWidth: 0,               // ✅ remove border
                                        hidden: !chart.isDatasetVisible(0),
                                        index: i,
                                    }));
                                },
                            },
                        },
                        tooltip: { enabled: true },
                    },
                    elements: {
                        arc: {
                            borderWidth: 0,
                        },
                    },
                    onClick: async (e, elements) => {
                        if (elements.length > 0) {
                            const index = elements[0].index;
                            const dept = templateData.labels[index];
                            if (userDept === 'IT') {
                                // setShowDoughnut(false);
                                await handleDepartmentClick(dept); // simulate clicking the dept to show bar chart
                            }
                        }
                    }
                },
                plugins: [
                    {
                        id: 'centerText',
                        beforeDraw(chart) {
                            const { ctx, chartArea, data } = chart;
                            const total = data.totalUsers || 0;

                            ctx.save();
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';

                            ctx.font = '20px Arial';
                            ctx.fillStyle = 'black';
                            ctx.fillText('Total', (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 - 20);

                            ctx.font = '30px Arial';
                            ctx.fillText(total.toString(), (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 + 10);

                            ctx.restore();
                        },
                    },
                    {
                        id: 'segment3DEffect',
                        afterDatasetDraw(chart) {
                            const { ctx } = chart;
                            const meta = chart.getDatasetMeta(0);
                            const dataset = chart.data.datasets[0];

                            ctx.save();

                            meta.data.forEach((arc, index) => {
                                const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;

                                const baseColor = dataset.backgroundColor[index];

                                const gradient = ctx.createRadialGradient(x, y, innerRadius, x, y, outerRadius);
                                gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)');
                                gradient.addColorStop(0.5, baseColor);
                                gradient.addColorStop(1, 'rgba(0, 0, 0, 0.15)');

                                ctx.fillStyle = gradient;

                                ctx.beginPath();
                                ctx.moveTo(x, y);
                                ctx.arc(x, y, outerRadius, startAngle, endAngle);
                                ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                                ctx.closePath();
                                ctx.fill();

                                ctx.shadowColor = 'rgba(0,0,0,0.08)';
                                ctx.shadowBlur = 3;
                                ctx.shadowOffsetX = 1;
                                ctx.shadowOffsetY = 1;

                                ctx.strokeStyle = 'rgba(0, 0, 0, 0.08)';
                                ctx.lineWidth = 1;
                                ctx.beginPath();
                                ctx.arc(x, y, outerRadius, startAngle, endAngle);
                                ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                                ctx.closePath();
                                ctx.stroke();

                                ctx.shadowColor = 'transparent';
                                ctx.shadowBlur = 0;
                                ctx.shadowOffsetX = 0;
                                ctx.shadowOffsetY = 0;
                            });

                            ctx.restore();
                        },
                    }
                    ,
                    {
                        id: 'segmentCounts',
                        afterDatasetDraw(chart) {
                            const { ctx } = chart;
                            const dataset = chart.data.datasets[0];
                            const meta = chart.getDatasetMeta(0);

                            ctx.save();
                            ctx.fillStyle = 'black';
                            ctx.font = 'bold 14px Arial';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';

                            meta.data.forEach((arc, index) => {
                                const { x, y } = arc.tooltipPosition();
                                const value = dataset.data[index];
                                ctx.fillText(value, x, y);
                            });

                            ctx.restore();
                        },
                    },
                ],


            });
        } else {
            if (userDept !== 'IT' || selectedTemplateDept) {

                createdTemplateChartInstance.current = new Chart(ctx, {
                    type: 'bar',
                    data: {

                        labels: [
                            `Created (${tableDetails?.created?.length || 0})`,
                            `Modified (${tableDetails?.updated?.length || 0})`,
                            `Inactive (${tableDetails?.inactive?.length || 0})`
                        ],
                        datasets: [


                            {
                                data: barChartData,
                                backgroundColor: function (context) {
                                    const chart = context.chart;
                                    const { ctx, chartArea } = chart;

                                    if (!chartArea) return null;

                                    // Gradients in the order: #07beb8 → #f25c54 → #133c55
                                    const gradient1 = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                                    gradient1.addColorStop(0, '#07beb8');
                                    gradient1.addColorStop(1, '#967aa1');

                                    const gradient2 = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                                    gradient2.addColorStop(0, '#f25c54');
                                    gradient2.addColorStop(1, '#967aa1');

                                    const gradient3 = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                                    gradient3.addColorStop(0, '#133c55');
                                    gradient3.addColorStop(1, '#967aa1');

                                    const gradients = [gradient1, gradient2, gradient3];
                                    return gradients[context.dataIndex];
                                },
                                borderRadius: 0,
                                barPercentage: 0.5,
                                categoryPercentage: 0.5,
                            }
                        ]

                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: { display: false },
                            tooltip: {
                                enabled: true,
                                callbacks: {
                                    title: (context) => context[0].label.split(" (")[0],  // Add this line
                                    label: (context) => `Count: ${context.parsed.y}`,    // Modified this line
                                }
                            },
                        },
                        scales: {
                            x: {
                                ticks: {
                                    color: 'black',
                                    maxRotation: 0,
                                    minRotation: 0,
                                    font: {
                                        size: 11, // Reduced font size (default is 12)
                                    }
                                },
                                grid: { display: false },
                                title: {
                                    display: true,
                                    text: 'Activity',
                                    color: 'black',
                                    font: {
                                        size: 14,
                                        weight: 'bold',
                                    },
                                },
                            },
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    color: "black",
                                    stepSize: 1, // ✅ Force whole number steps
                                    callback: function (value) {
                                        return Number.isInteger(value) ? value : null; // Optional: hides non-integers just in case
                                    }
                                },
                                title: {
                                    display: true,
                                    text: "Count",
                                    color: "black",
                                    font: { size: 14, weight: "bold" },
                                },
                            },

                        },
                        onClick: function (event, elements) {
                            const points = createdTemplateChartInstance.current.getElementsAtEventForMode(
                                event,
                                'nearest',
                                { intersect: true },
                                true
                            );

                            if (points.length) {
                                const clickedIndex = points[0].index;
                                const label = this.data.labels[clickedIndex].split(' ')[0]; // Extract base label
                                const actionKey = label === 'Modified' ? 'updated' : label.toLowerCase(); // Map to data key
                                setSelectedAction(actionKey);
                            }
                        },

                    },
                    plugins: [
                        {
                            id: 'segment3DEffect',
                            afterDatasetDraw(chart) {
                                const { ctx } = chart;
                                const meta = chart.getDatasetMeta(0);
                                const dataset = chart.data.datasets[0];

                                ctx.save();

                                meta.data.forEach((arc, index) => {
                                    const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;
                                    const baseColor = dataset.backgroundColor[index];

                                    // Use flat color instead of gradient
                                    ctx.fillStyle = baseColor;

                                    ctx.beginPath();
                                    ctx.moveTo(x, y);
                                    ctx.arc(x, y, outerRadius, startAngle, endAngle);
                                    ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                                    ctx.closePath();
                                    ctx.fill();

                                    // Shadow effect for 3D appearance
                                    ctx.shadowColor = 'rgba(0,0,0,0.08)';
                                    ctx.shadowBlur = 3;
                                    ctx.shadowOffsetX = 1;
                                    ctx.shadowOffsetY = 1;

                                    ctx.strokeStyle = 'rgba(0, 0, 0, 0.08)';
                                    ctx.lineWidth = 1;
                                    ctx.beginPath();
                                    ctx.arc(x, y, outerRadius, startAngle, endAngle);
                                    ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                                    ctx.closePath();
                                    ctx.stroke();

                                    // Reset shadow for next drawing
                                    ctx.shadowColor = 'transparent';
                                    ctx.shadowBlur = 0;
                                    ctx.shadowOffsetX = 0;
                                    ctx.shadowOffsetY = 0;
                                });

                                ctx.restore();
                            },
                        }

                    ],
                });
            }
        }

    }, [currentSlide, templateData, selectedTemplateDept, barChartData, showDoughnut]);


    // ---- END DOUHGNUT CAHRT TEMPLATE ----------------


    // ============== BARCHART FOR THE PARTICULAR DEPARTMENT  ===================

    const isBarChartEmpty =
        userDept !== 'IT' &&
        !showDoughnut &&
        barChartData?.every(count => count === 0);

    const handleDepartmentClick = async (dept) => {
        setSelectedTemplateDept(dept); // Store for later use
        try {
            setIsLoading(true);
            const userId = Number(localStorage.getItem('userid'));
            const userRole = localStorage.getItem('userRole');
            const department = localStorage.getItem('dept');
            const activity = 'C';
            const config = {
                headers: { userId, "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { userId, userRole, Activity: activity, dept: department },
            };

            const response = await axios.post(Audit, {}, config);


            const actions = response.data.userDetails.actions;
            const inactiveTemplates = response.data.inactiveTemplates[dept];

            let createdCount = 0;
            let updatedCount = 0;
            let inactiveCount = 0;

            let createdTables = [];
            let updatedTables = [];
            let inactiveTables = [];

            actions.forEach((action) => {
                if (action.actionType === 'Created a Template' && action.actionDetails[dept]) {
                    createdCount = action.actionDetails[dept].count;
                    createdTables = action.actionDetails[dept].tables;
                }
                if (action.actionType === 'Updated a Template' && action.actionDetails[dept]) {
                    updatedCount = action.actionDetails[dept].count;
                    updatedTables = action.actionDetails[dept].tables;
                }
            });

            if (inactiveTemplates && Array.isArray(inactiveTemplates.tables)) {
                inactiveCount = inactiveTemplates.count;
                inactiveTables = inactiveTemplates.tables;
            }

            if (createdTemplateChartInstance.current) {
                createdTemplateChartInstance.current.data.datasets[0].data = [createdCount, updatedCount, inactiveCount];
                createdTemplateChartInstance.current.update();
            }

            setBarChartData([createdCount, updatedCount, inactiveCount]);
            setTableDetails({
                created: createdTables,
                updated: updatedTables,
                inactive: inactiveTables,
            });
            setIsLoading(false);
        } catch (err) {
            console.error(`Failed to fetch data for department ${dept}:`, err);
        }
    };

    // render table for the Template details

    const isWithinDateRange = (dateStr, range) => {
        if (range === "All") return true;

        const targetDate = new Date(dateStr);
        const today = new Date();

        // Normalize both dates to midnight (ignore time)
        targetDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        const daysMap = {
            "Today": 0,
            "Last 3 Days": 2,  // Today + 2 previous = 3 days
            "Last 7 Days": 6,
            "Last 30 Days": 29,
        };
        const diffTime = today - targetDate;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        return diffDays >= 0 && diffDays <= daysMap[range];
    };

    const isWithinDateRangetemplate = (timestamp, range) => {
        if (range === 'All') return true;

        const daysMap = {
            'Today': 0,
            'Last 3 Days': 3,
            'Last 7 Days': 7,
            'Last 30 Days': 30,
        };

        const targetDate = new Date(timestamp);
        const today = new Date();

        // Remove time from comparison
        targetDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        const diffTime = today - targetDate;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        return diffDays <= daysMap[range];
    };

    // ------ START RENDER TABLE USERS AND TEMPLATE  ================================

    const renderTable = (title, data, type, count, dateFilter) => {
        const safeData = Array.isArray(data) ? data : [];

        const getDateLabel = () => {
            if (type === 'created') return 'Created Date';
            if (type === 'updated') return 'Modified Date';
            if (type === 'inactive') return 'Last Active Date';
            return 'Date';
        };
        const formatDate = (timestamp) => {
            if (!timestamp) return 'n/a';

            const date = new Date(timestamp);
            if (isNaN(date)) return 'n/a';

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        };

        const formatTableName = (name) => {
            if (!name) return 'n/a';
            const nameWithoutPrefix = name.includes('_') ? name.substring(name.indexOf('_') + 1) : name;
            return nameWithoutPrefix
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        };

        const filteredData = safeData.filter((item) => {
            const detail = item.details?.[0] || item.actionDetails?.[0];
            return isWithinDateRangetemplate(detail?.Timestamp, dateFilter);
        });

        return (
            <div className={`tableWrapper ${tableStyles.notificationWrapper}`}>
                <h5 style={{ marginBottom: '8px', textTransform: 'capitalize', fontSize: '0.9rem' }}>
                    <span style={{ fontWeight: 'bold' }}>{title}</span>
                    <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>- {filteredData.length}</span>
                </h5>
                <hr style={{ margin: '4px 0 8px 0', borderColor: 'black', borderTopWidth: '1px' }} />
                <div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                            {filteredData.map((item, index) => {
                                const detail = item.details?.[0] || item.actionDetails?.[0];
                                const tableName = formatTableName(detail?.Tablename || item.tableName);
                                const timestamp = formatDate(detail?.Timestamp);

                                return (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td style={{ fontSize: "0.75rem", fontWeight: "bold", paddingBottom: "2px" }}>
                                                {tableName}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ fontSize: "0.7rem", paddingBottom: "4px" }}>
                                                {getDateLabel()} : {timestamp}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <hr style={{ margin: "4px 0", borderColor: "black", borderTopWidth: "1px" }} />
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderUserRoleTable = (role, filteredUsers) => {
        const formatDate = (dateString) => {
            if (!dateString) return 'N/A';
            const date = new Date(dateString);
            if (isNaN(date)) return 'Invalid Date';

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        };

        const roleTitleMap = {
            admin: 'Manager',
            // add more roles here
        };

        const normalizedRole = role?.trim().toLowerCase() || '';
        const displayTitle = roleTitleMap[normalizedRole] || role;

        const filteredByDate = filteredUsers.filter(user =>
            isWithinDateRange(user.accountCreatedDate, userDateFilter)
        );

        return (
            <div className={`tableWrapper ${tableStyles.notificationWrapper}`}>
                <h5 style={{ marginBottom: '8px', textTransform: 'capitalize', fontSize: '0.9rem' }}>
                    <span style={{ fontWeight: 'bold' }}>{displayTitle}</span>
                    <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>- {filteredByDate.length}</span>
                </h5>
                <hr style={{ margin: '4px 0 8px 0', borderColor: 'black', borderTopWidth: '1px' }} />

                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                        {filteredByDate.map((user, index) => {
                            const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
                            const fullName = `${capitalize(user.firstName)} ${user.lastName || ''}`.trim();
                            return (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td style={{ fontSize: "0.75rem", fontWeight: "bold", paddingBottom: "2px" }}>
                                            {fullName}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: "0.7rem", paddingBottom: "4px" }}>
                                            Created Date: {formatDate(user.accountCreatedDate)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <hr style={{ margin: "4px 0", borderColor: "black", borderTopWidth: "1px" }} />
                                        </td>
                                    </tr>
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    };


    // ------ END RENDER TABLE USERS AND TEMPLATE  ================================
    const handleBackToSummary1 = async () => {

        if (selectedTemplateDept) {
            setTimeout(async () => {
                await handleDepartmentClick(selectedTemplateDept); // Reload bar chart
            }, 100);
        }

        setSelectedAction(null); // Clear table view
    };

    const handleBackToSummary = () => {

        setSelectedTemplateDept(null);
        setSelectedAction(null);
        setShowDoughnut(true);

        fetchDataAndDrawChart(); // 🧠 reload all departments
    };



    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    // ----------  START THE IT (Admin) AND OTHER ADMINS CHART AND GENERATE PDF ----------





    // ----------  END THE IT (Admin) AND OTHER ADMINS CHART AND GENERATE PDF ----------


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>

                            </ol>
                        </nav>
                    </div>


                    <div className="dropdown ms-auto mt-2 mt-md-0">
                        <button className="btn btn-outline-dark btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Quick Links
                        </button>
                        <ul className={`dropdown-menu dropdown-menu-end ${styles.dropdownMenu}`}>
                            {userDept === "IT" ? (
                                <>
                                    <li>
                                        <a className={`dropdown-item small ${styles.dropdownItem}`} style={{ cursor: 'pointer' }} onClick={handleUserCreations}>
                                            <i className="bi bi-person-plus me-2"></i>Register New User
                                        </a>
                                    </li>
                                    <li>
                                        <a className={`dropdown-item small ${styles.dropdownItem}`} style={{ cursor: 'pointer' }} onClick={handleUserModify}>
                                            <i className="bi bi-person-bounding-box me-2"></i>User Access Control
                                        </a>
                                    </li>
                                    <li>
                                        <a className={`dropdown-item small ${styles.dropdownItem}`} style={{ cursor: 'pointer' }} onClick={handleReAssign}>
                                            <i className="bi bi-shuffle me-2"></i>Re-Assign Template
                                        </a>
                                    </li>
                                </>
                            ) : (
                                <li>
                                    <a className={`dropdown-item small ${styles.dropdownItem}`} style={{ cursor: 'pointer' }} onClick={handleReAssign}>
                                        <i className="bi bi-shuffle me-2"></i>Re-Assign Template
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>

                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="col-lg-9 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="mb-2">
                                            <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>Manager Work Area</h6>
                                            <div id="group1" className="row">
                                                <div className="col-3 mb-1">
                                                    <div
                                                        className={`${styles.customBox} ${styles.csBoxMain} ${styles.activeBox}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                    >
                                                        <a onClick={handleFbc} className="text-decoration-none text-reset d-block">
                                                            <i className="bi bi-file-code"></i><br />
                                                            1.1 File Based Creation
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col-3 mb-1">
                                                    <div className={`${styles.customBox} ${styles.csBoxBlue} ${styles.activeBox}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top">
                                                        <a onClick={handleIbm} className="text-decoration-none text-reset d-block">
                                                            <i className="bi bi-grid"></i><br />
                                                            1.2 Interactive Builder
                                                        </a>

                                                    </div>
                                                </div>
                                                <div className="col-3 mb-1">
                                                    <div className={`${styles.customBox} ${styles.csBoxDarkGreen} ${styles.activeBox}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top">
                                                        <a onClick={handleDashboardAI} className="text-decoration-none text-reset d-block">
                                                            <i className="bi bi-chat-dots"></i><br />
                                                            1.3 Interactive Builder (AI)
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col-3 mb-1">
                                                    <div className={`${styles.customBox} ${styles.csBoxPurple} ${styles.activeBox}`}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top">
                                                        <a onClick={handleModiyTemplate} className="text-decoration-none text-reset d-block">
                                                            <i className="bi bi bi-pencil"></i><br />
                                                            1.4 Modify Existing Template
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                        <div
                                            style={{
                                                backgroundImage: `url(${greenbg})`,
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center',
                                                borderRadius: '20px',
                                                paddingTop: '6px',
                                                paddingBottom: '6px',
                                                paddingLeft: '20px',
                                                paddingRight: '20px',
                                                width: '75%',
                                                // height: '170px'  REMOVE THIS
                                                minHeight: '100px', //  Optional - ensures at least this much space,
                                                marginTop: '20px',
                                            }}
                                        >

                                            <h6 className={`pb-1 mb-4 ${styles.borderBottom}`}>Gapsphere Workflow</h6>
                                            <div style={{ width: '134%', height: '100%' }}>
                                                <div className={`row ${styles.group3}`}>

                                                    <div className="col-3 mb-1">
                                                        <div className={`${styles.customtemplatebox} ${styles.highlightGlow} ${styles.activeBox} ${styles.box}`}>
                                                            <div className="template-text">1. Template Creation</div>
                                                            <div className="template-icon">
                                                                <i className="bi bi-file-earmark-plus"></i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-3 mb-1">

                                                        <div className={`${styles.customtemplatebox} ${styles.disabledBox} ${styles.box}`}>
                                                            <div className="template-text">2. Data Submission</div>
                                                            <div className="template-icon2">
                                                                <i className="bi bi-journals"></i>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="col-3 mb-1">
                                                        <div className={`${styles.customtemplatebox} ${styles.disabledBox} ${styles.box}`}>
                                                            <div className="template-text">3. Data Review</div>
                                                            <div className="template-icon3">
                                                                <i className="bi bi-check-circle"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        {/* Slider Controls and Heading in One Row */}
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            {/* Previous button - only show for IT users or when appropriate */}
                                            {userDept === 'IT' && ((currentSlide === 0 && !selectedDepartment) || (currentSlide === 1 && !selectedTemplateDept)) && (
                                                <button className="btn btn-outline-secondary btn-sm" onClick={handlePrev}>
                                                    <i className="bi bi-chevron-left"></i>
                                                </button>
                                            )}

                                            {/* Heading and Back to Summary buttons */}
                                            <div className="d-flex align-items-center flex-grow-1 justify-content-center mx-2">
                                                <h6 className="text-dark fw-semibold small mb-0 text-center">
                                                    {userDept === 'IT' ? (
                                                        currentSlide === 0
                                                            ? (selectedDepartment
                                                                ? `Users Summary By Department - ${selectedDepartment}`
                                                                : 'Users Summary By Department')
                                                            : (selectedTemplateDept
                                                                ? `Templates Summary By Department - ${selectedTemplateDept}`
                                                                : 'Templates Summary By Department')
                                                    ) : (
                                                        selectedTemplateDept
                                                            ? `Templates Summary By Department - ${selectedTemplateDept}`
                                                            : 'Templates Summary By Department'
                                                    )}
                                                </h6>

                                                {/* Back to Summary (Users) - only for IT users */}
                                                {userDept === 'IT' && currentSlide === 0 && (selectedDepartment || selectedRole) && (
                                                    <button
                                                        className="btn btn-white btn-sm d-flex align-items-center"
                                                        onClick={() => {
                                                            if (selectedRole && filteredUsers) {
                                                                setSelectedRole(null);
                                                                renderBarChart(selectedDepartment);
                                                            } else if (selectedDepartment) {
                                                                setSelectedDepartment(null);
                                                            }
                                                        }}
                                                        title="Back to Summary"
                                                        style={{ padding: '4px 8px' }}
                                                    >
                                                        <i className="bi bi-arrow-left-circle" style={{ fontSize: '12px', color: 'black' }}></i>
                                                    </button>
                                                )}

                                                {/* Back to Summary (Templates) */}
                                                {currentSlide === 1 && selectedTemplateDept && (
                                                    <>
                                                        {selectedTemplateDept && selectedAction ? (
                                                            <button
                                                                className="btn btn-white btn-sm d-flex align-items-center"
                                                                onClick={handleBackToSummary1}
                                                                title="Back to Templates Chart"
                                                                style={{ padding: '4px 8px' }}
                                                            >
                                                                <i className="bi bi-arrow-left-circle" style={{ fontSize: '12px', color: 'black' }}></i>
                                                            </button>
                                                        ) : userDept === 'IT' ? (
                                                            <button
                                                                className="btn btn-white btn-sm d-flex align-items-center"
                                                                onClick={handleBackToSummary}
                                                                title="Back to Users Chart"
                                                                style={{ padding: '4px 8px' }}
                                                            >
                                                                <i className="bi bi-arrow-left-circle" style={{ fontSize: '12px', color: 'black' }}></i>
                                                            </button>
                                                        ) : null}
                                                    </>
                                                )}
                                            </div>

                                            {/* Next button - only show for IT users */}
                                            {userDept === 'IT' && ((currentSlide === 0 && !selectedDepartment) || (currentSlide === 1 && !selectedTemplateDept)) && (
                                                <button className="btn btn-outline-secondary btn-sm" onClick={handleNext}>
                                                    <i className="bi bi-chevron-right"></i>
                                                </button>
                                            )}
                                        </div>

                                        {/* Users Summary Chart - only for IT users */}
                                        {userDept === 'IT' && currentSlide === 0 && (
                                            selectedRole && filteredUsers.length > 0 ? (
                                                <div
                                                    className="custom-scrollbar"
                                                    style={{
                                                        height: '280px',
                                                        overflowY: 'auto',
                                                        marginTop: '0.5rem',
                                                    }}
                                                >
                                                    {renderUserRoleTable(selectedRole, filteredUsers)}
                                                </div>
                                            ) : (
                                                <div
                                                    ref={chartContainerRef}
                                                    id="user-report-container"
                                                    style={{ position: 'relative', height: '280px' }}
                                                >
                                                    {isLoading ? (
                                                        <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                                                            <span className="mt-2 text-muted">Loading chart</span>
                                                            <img src={loadingGif} alt="Loading..." style={{ width: '60px', height: '60px' }} />
                                                        </div>
                                                    ) : (
                                                        <canvas ref={chartRef} style={{ width: '100%', height: '100%' }} />
                                                    )}
                                                </div>
                                            )
                                        )}
                                        {/* Templates Summary Chart - always show */}
                                        {(userDept !== 'IT' || currentSlide === 1) && (
                                            selectedAction ? (
                                                <div
                                                    className="custom-scrollbar"
                                                    style={{
                                                        height: '280px',
                                                        overflowY: 'auto',
                                                        marginTop: '0.5rem',
                                                    }}
                                                >
                                                    {selectedAction === 'created' &&
                                                        renderTable("Created templates", tableDetails?.created || [], 'created', selectedCreatedCount, templateDateFilter)}

                                                    {selectedAction === 'updated' &&
                                                        renderTable("Modified templates", tableDetails?.updated || [], 'updated', selectedUpdatedCount, templateDateFilter)}

                                                    {selectedAction === 'inactive' &&
                                                        renderTable("Inactive templates", tableDetails?.inactive || [], 'inactive', selectedInactiveCount, templateDateFilter)}
                                                </div>
                                            ) : isLoading ? (
                                                <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                                                    <span className="mt-2 text-muted">Loading chart</span>
                                                    <img src={loadingGif} alt="Loading..." style={{ width: '60px', height: '60px' }} />
                                                </div>
                                            ) : isBarChartEmpty ? (
                                                <div>
                                                    <p className="text-center py-5">No activity(s) performed by the User</p>
                                                </div>
                                            ) : (
                                                <div ref={templateinforef} style={{ position: 'relative', height: '280px' }}>
                                                    <canvas ref={createdTemplateChartRef} style={{ width: '100%', height: '100%' }} />
                                                </div>
                                            )
                                        )}


                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Adashboard;
